import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

/**
 * PlaceholderImage — the standard "no photo" fallback: a flat pale-harbour tile
 * with an icon + label, instead of a blank/broken box. Use this anywhere a
 * cover/thumbnail can be missing.
 *
 * Flat since the 2026-10-01 visual refresh (no decorative gradients). The
 * `gradient` prop is still accepted so existing call sites don't break, but it
 * is ignored — every placeholder looks the same, which is the point.
 *
 * @param {string} title    - label shown under the icon
 * @param {{icon?: string, label?: string}} badge - optional icon/label source
 * @param {string} type     - content type (accepted for call-site compatibility)
 * @param {string} gradient - ignored (kept for call-site compatibility)
 */
// eslint-disable-next-line no-unused-vars
export default function PlaceholderImage({ type, title, badge, gradient }) {
  const { t } = useTranslation();
  return (
    <div className="w-full h-full bg-primary-lighter flex items-center justify-center">
      <div className="text-center text-primary-dark px-4">
        {/* mx-auto — preflight svgs are block-level; text-center can't center them */}
        <div className="mb-2 opacity-70"><Icon name={badge?.icon || 'mapPin'} className="w-12 h-12 mx-auto" /></div>
        <div className="text-lg font-medium truncate max-w-[200px]">
          {title || badge?.label || t('placeholderImage.itemFallback')}
        </div>
      </div>
    </div>
  );
}
